import { Component } from "@angular/core";
import { FileDataService } from "../../commons/file-data.service";
import { MapDataService } from "../../commons/map-data.service";
import { Folder, Dataset } from "4d-mapper";
import { Subscription } from "rxjs";


@Component({
    selector: 'upload-comp',
    templateUrl: './upload.component.html',
    styleUrls: ['./upload.component.scss'],
})
export class UploadComponent {
    mode:string
    folder:Folder
    private _subs:Subscription[] = []
    constructor(private fileManager:FileDataService, private mapData:MapDataService){}

    ngOnInit(){
        this._subs.push(this.mapData.sceneFolder.state.subscribe(s => 
            this.folder = s
        ))
    }
    ngOnDestroy(){
        this._subs.forEach(s => s.unsubscribe())
    }
    uploadFiles(ds:Dataset[]){
        // TODO fix type, its photos with a s
        this.mapData.scene.value.addFromFiles(ds).subscribe(r => {
            if(!r['photos'].length && !r['transforms'].length)
                alert('none of these files have transforms')
        })
        this.mode = null
    }
    uploadFolder(f:Folder){
        this.mapData.scene.value.addImagesFromFolder(f).subscribe()
        this.mode = null
    }

    upload(e){
        this.fileManager.uploadFiles(Array.from(e.srcElement.files),this.folder)
    }
}  